import Crypto from "crypto-js";
import env from "../config/env";
import { UserDto } from "../modules/Account/AccountLogin/types";
import clientStorage from "./clientStorage";
const { COOKIE_HASH } = env;

const header = {
  alg: "SHA256",
  typ: "JWT",
};

const base64url = (source: any) => {
  // Encode in classical base64
  let encodedSource = Crypto.enc.Base64.stringify(source);

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, "");

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");

  return encodedSource;
};

const getSessionKey = () => clientStorage.getItem("session_key");
const setSessionKey = (sessionKey: string) => {
  clientStorage.removeItem("session_key");
  clientStorage.setItem("session_key", sessionKey);
};
const purgeSessionKey = () => clientStorage.removeItem("session_key");

const getSecondarySessionKey = () =>
  clientStorage.getItem("secondary_session_key");
const setSecondarySessionKey = (sessionKey: string) => {
  clientStorage.removeItem("secondary_session_key");
  clientStorage.setItem("secondary_session_key", sessionKey);
};
const purgeSecondarySessionKey = () =>
  clientStorage.removeItem("secondary_session_key");

const getUser = () => clientStorage.getItem("user");
const setUser = (user: UserDto) => {
  clientStorage.removeItem("user");
  clientStorage.setItem("user", JSON.stringify(user));
};
const purgeUser = () => clientStorage.removeItem("user");

const getSecondaryUser = () => clientStorage.getItem("secondary_user");
const setSecondaryUser = (user: UserDto) => {
  clientStorage.removeItem("secondary_user");
  clientStorage.setItem("secondary_user", JSON.stringify(user));
};
const purgeSecondaryUser = () => clientStorage.removeItem("secondary_user");

// const createSessionKey = (data: any) => {
//   const stringifiedHeader = Crypto.enc.Utf8.parse(JSON.stringify(header));
//   const encodedHeader = base64url(stringifiedHeader);

//   const stringifiedData = Crypto.enc.Utf8.parse(JSON.stringify(data));
//   const encodedData = base64url(stringifiedData);
//   let obje: Object = COOKIE_HASH;
//   let signature: any = Crypto.SHA256(encodedHeader + "." + encodedData, obje);
//   signature = base64url(signature);

//   return encodedHeader + "." + encodedData + "." + signature;
// };

export {
  getSessionKey,
  setSessionKey,
  purgeSessionKey,
  getUser,
  setUser,
  purgeUser,
  getSecondarySessionKey,
  setSecondarySessionKey,
  purgeSecondarySessionKey,
  getSecondaryUser,
  setSecondaryUser,
  purgeSecondaryUser,
};
